export default __webpack_public_path__ + "static/media/island_4.1d2de5e8.png";